"use strict";
//
//  OMRealtimeAPIClient.ts
//  Firmament
//
//  Created by Cheong Kit Tham on 04/06/2020.
//  Copyright © 2020 Apptivity Lab. All rights reserved.
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const __1 = require("..");
class OMRealtimeClient {
    constructor() {
        this.subscribedEvents = [];
    }
    get socketManager() {
        if (this._socketManager) {
            return this._socketManager;
        }
        return this.initSocketManager();
    }
    get defaultSocket() {
        if (this._defaultSocket) {
            return this._defaultSocket;
        }
        const _ = this.socketManager;
        return this.defaultSocket;
    }
    tenant(env) {
        const splitted = new URL(__1.OMUniverse.shared.baseURL).pathname.split("/");
        return splitted[splitted.length - 1] || "";
    }
    socketScheme(env) {
        return new URL(__1.OMUniverse.shared.baseURL).protocol === "https:" ? "wss:" : "ws:";
    }
    initSocketManager() {
        const url = new URL(__1.OMUniverse.shared.baseURL);
        const socketHost = url.hostname;
        const connectParams = {
            "Authorization": __1.OMUniverse.shared.session && `Bearer ${__1.OMUniverse.shared.session.token}`,
            "Tenant": this.tenant(__1.OMUniverse.shared.environment),
            "X-Harbour-Application-Key": __1.OMUniverse.shared.applicationKey,
        };
        const defaultSocket = socket_io_client_1.default(socketHost, {
            forceNew: true,
            query: connectParams,
            secure: this.socketScheme(__1.OMUniverse.shared.environment) === "wss:",
            transports: ["websocket"],
        });
        this._defaultSocket = defaultSocket;
        this._socketManager = defaultSocket.io;
        defaultSocket.once("connect", () => {
            this.subscribedEvents.forEach(([event, subscription]) => {
                this.subscribe(event, subscription);
            });
        });
        defaultSocket.on("reconnect", () => {
            (() => __awaiter(this, void 0, void 0, function* () {
                defaultSocket.removeAllListeners();
                defaultSocket.close(); // alias defaultSocket.disconnect()
                if (!__1.OMUniverse.shared.session) {
                    return;
                }
                if (__1.OMUniverse.shared.session.shouldRenewAt.isSameOrBefore(new Date())) {
                    yield new Promise((resolve) => setTimeout(resolve, 0));
                    if (__1.OMUniverse.shared.extendOrRenewSessionPromise) {
                        yield __1.OMUniverse.shared.extendOrRenewSessionPromise;
                    }
                    else {
                        yield __1.OMUniverse.shared.extendOrRenewSession();
                    }
                }
                this.initSocketManager();
            }))();
        });
        return defaultSocket.io;
    }
    // tslint:disable-next-line:member-ordering
    subscribe(event, subscription) {
        const callback = () => {
            this.defaultSocket.once("subscribed", (subscribedRoom) => {
                if (event !== subscribedRoom) {
                    return;
                }
                if (!this.subscribedEvents.find(([cachedEvent, cachedSubscription]) => {
                    return cachedEvent === event && cachedSubscription === subscription;
                })) {
                    this.subscribedEvents.push([event, subscription]);
                }
                const emitter = this.defaultSocket.on(subscribedRoom, (data) => {
                    if (subscription.socketEventHandler) {
                        subscription.socketEventHandler(data);
                    }
                });
                subscription.socketHandlerId = emitter.id;
            });
            this.defaultSocket.on("subscribe_error", (namespace) => {
                if (subscription.errorHandler) {
                    subscription.errorHandler(new Error(`Failed subscribing to namespace: ${namespace}`));
                }
            });
            this.defaultSocket.emit("subscribe", event);
        };
        if (this.defaultSocket.disconnected) {
            this.defaultSocket.on("connection_ready", callback);
        }
        else {
            callback();
        }
    }
    // tslint:disable-next-line:member-ordering
    unsubscribe(handlerId) {
        const existingHandler = this.defaultSocket;
        existingHandler.off(handlerId);
        this.defaultSocket.emit("unsubscribe", handlerId);
        // this.defaultSocket.off(id: handlerId)
        // tslint:disable-next-line:max-line-length
        // let similarHandlers = self.defaultSocket?.handlers.filter { $0.event == existingHandler.event && $0.id != existingHandler.id } ?? []
        // if similarHandlers.isEmpty {
        //     self.defaultSocket?.emit("unsubscribe", with: [existingHandler.event])
        //     self.subscribedEvents.remove(existingHandler.event)
        // }
        // /// If we are no longer interested in any realtime events, we should just disconnect instead of
        // /// hogging resources by keeping the connection.
        // if self.subscribedEvents.isEmpty {
        //     self.disconnectRealtime()
        // }
        this.disconnectRealtime();
    }
    // tslint:disable-next-line:member-ordering
    disconnectRealtime() {
        this.subscribedEvents.forEach(([event]) => {
            this.defaultSocket.emit("unsubscribe", event);
            this.defaultSocket.off(event);
        });
        this.subscribedEvents = [];
        // this.defaultSocket.disconnect()
        this._defaultSocket = undefined;
        this._socketManager = undefined;
    }
}
exports.OMRealtimeClient = OMRealtimeClient;
//# sourceMappingURL=OMRealtimeAPIClient.js.map